var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('side-bar',{attrs:{"background-color":_vm.sidebarBackground,"short-title":"WFIWS EMS","title":"WFIWS EMS"}},[_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
        name: 'Dashboard',
        icon: 'fa fa-tv text-primary',
        path: '/admin/dashboard',
      }}}),(_vm.giftaway_access)?_c('div',{staticClass:"dropdown-divider"}):_vm._e(),(_vm.giftaway_access)?_c('h6',{staticClass:"ml-3 navbar-heading text-muted"},[_vm._v(" Giftaway ")]):_vm._e(),(_vm.giftaway_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Merchant List',
        icon: 'fa fa-store text-purple',
        path: '/admin/giftaway/merchants',
      }}}):_vm._e(),(_vm.giftaway_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Redeem Transaction',
        icon: 'fa fa-tasks text-green',
        path: '/admin/giftaway/transaction',
      }}}):_vm._e(),(_vm.prizeItem_access)?_c('div',{staticClass:"dropdown-divider"}):_vm._e(),(_vm.prizeItem_access)?_c('h6',{staticClass:"ml-3 navbar-heading text-muted"},[_vm._v(" Prize Item ")]):_vm._e(),(_vm.prizeItem_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Prize Item Config',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/PrizeItemConfig',
      }}}):_vm._e(),(_vm.prizeItem_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Special Prize Condition Config',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/SpecialPrizeConditionConfig',
      }}}):_vm._e(),(_vm.globalPromo_access)?_c('div',{staticClass:"dropdown-divider"}):_vm._e(),(_vm.globalPromo_access)?_c('h6',{staticClass:"ml-3 navbar-heading text-muted"},[_vm._v(" Global Promo Configuration ")]):_vm._e(),(_vm.promo_config_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Promo Config',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/GlobalPromoConfig',
      }}}):_vm._e(),(_vm.rules_config_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Rules Config',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/GlobalPromoRules',
      }}}):_vm._e(),(_vm.trigger_config_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Trigger Config',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/GlobalPromoTrigger',
      }}}):_vm._e(),(_vm.flash_promo_config_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Flash Promo Config',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/FlashPromoConfigs',
      }}}):_vm._e(),(_vm.raffle_access)?_c('div',{staticClass:"dropdown-divider"}):_vm._e(),(_vm.raffle_access)?_c('h6',{staticClass:"ml-3 navbar-heading text-muted"},[_vm._v(" Raffle Configuration ")]):_vm._e(),(_vm.raffle_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Raffle Event',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/raffle/RaffleEvent',
      }}}):_vm._e(),(_vm.raffle_winner_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Raffle Event Winner',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/raffle/RaffleEventWinner',
      }}}):_vm._e(),(_vm.province_access)?_c('div',{staticClass:"dropdown-divider"}):_vm._e(),(_vm.province_access)?_c('h6',{staticClass:"ml-3 navbar-heading text-muted"},[_vm._v(" Province City Configuration ")]):_vm._e(),(_vm.province_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Province City',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/provinceCity/ProvinceCity',
      }}}):_vm._e(),(_vm.giftaway_access)?_c('div',{staticClass:"dropdown-divider"}):_vm._e(),(_vm.giftaway_access)?_c('h6',{staticClass:"ml-3 navbar-heading text-muted"},[_vm._v(" User Task Configuration ")]):_vm._e(),(_vm.giftaway_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'User Task Config',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/userTask/UserTaskConfig',
      }}}):_vm._e(),(_vm.giftaway_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'User Task Rules Config',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/userTask/UserTaskRulesConfig',
      }}}):_vm._e(),(_vm.giftaway_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'User Task Reaction Config',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/userTask/UserTaskReactionConfig',
      }}}):_vm._e(),(_vm.giftaway_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'User Task Response Config',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/userTask/UserTaskResponseConfig',
      }}}):_vm._e(),(_vm.giftaway_access)?_c('div',{staticClass:"dropdown-divider"}):_vm._e(),(_vm.giftaway_access)?_c('h6',{staticClass:"ml-3 navbar-heading text-muted"},[_vm._v(" Stream Configuration ")]):_vm._e(),(_vm.giftaway_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Stream Config',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/stream',
      }}}):_vm._e(),(_vm.promoter_access)?_c('div',{staticClass:"dropdown-divider"}):_vm._e(),(_vm.promoter_access)?_c('h6',{staticClass:"ml-3 navbar-heading text-muted"},[_vm._v(" Promoter Configuration ")]):_vm._e(),(_vm.promoter_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Promoter Config',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/PromoterConfig',
      }}}):_vm._e(),(_vm.game_configuration_access)?_c('div',{staticClass:"dropdown-divider"}):_vm._e(),(_vm.game_configuration_access)?_c('h6',{staticClass:"ml-3 navbar-heading text-muted"},[_vm._v(" Game Configuration ")]):_vm._e(),(_vm.game_configuration_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Game Config',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/GameConfiguration',
      }}}):_vm._e(),(_vm.userIsAdmin)?_c('div',{staticClass:"dropdown-divider"}):_vm._e(),(_vm.userIsAdmin)?_c('h6',{staticClass:"ml-3 navbar-heading text-muted"},[_vm._v(" Role Mapping Configuration ")]):_vm._e(),(_vm.userIsAdmin)?_c('sidebar-item',{attrs:{"link":{
        name: 'Role Mapping Config',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/RoleMappingConfig',
      }}}):_vm._e(),(_vm.report_access)?_c('div',{staticClass:"dropdown-divider"}):_vm._e(),(_vm.report_access)?_c('h6',{staticClass:"ml-3 navbar-heading text-muted"},[_vm._v(" Report ")]):_vm._e(),(_vm.account_status_report_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Account Status Report',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/AccountStatusReport',
      }}}):_vm._e(),(_vm.justscan_report_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Just Scan Registration Report',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/JustScanReport',
      }}}):_vm._e(),(_vm.daily_login_report_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Daily Login Report',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/DailyLoginReport',
      }}}):_vm._e(),(_vm.game_leaderboard_report_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Game Leaderboard Report',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/GameLeaderboardReport',
      }}}):_vm._e(),(_vm.game_daily_play_report_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Game Daily Play Report',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/GameDailyPlayReport',
      }}}):_vm._e(),(_vm.las_donation_report_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'LAS Donation Report',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/LASDonationReport',
      }}}):_vm._e(),(_vm.ems_tracking_upc_multiply_report)?_c('sidebar-item',{attrs:{"link":{
        name: 'EMS Tracking UPC Multiply Report',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/EMSTrackingUPCMultiplyReport',
      }}}):_vm._e(),(_vm.las_activity_reward_transaction_report)?_c('sidebar-item',{attrs:{"link":{
        name: 'LAS Activity Reward Transaction Report',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/LASActivityRewardTransactionReport',
      }}}):_vm._e(),(_vm.shipping_receipt_report_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Shipping Receipt Report',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/ShippingReceiptReport',
      }}}):_vm._e(),(_vm.ugc_artWork_contest_report_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'UGC Artwork Contest Report',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/UGCArtworkContestReport',
      }}}):_vm._e(),(_vm.ugc_artWork_votes_report_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'UGC Artwork Votes Report',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/UGCArtworkVotesReport',
      }}}):_vm._e(),(_vm.global_promo_transaction_report_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Global Promo Transaction Report',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/GlobalPromoTransactionReport',
      }}}):_vm._e(),(_vm.upc_transaction_report_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'UPC Transaction Report',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/UPCTransactionReport',
      }}}):_vm._e(),(_vm.upc_classification_report_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'UPC LAS Classification Report',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/UPCLASClassificationReport',
      }}}):_vm._e(),(_vm.affiliator_referral_code_report_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Affiliator Referral Code Report',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/AffiliatorReferralCodeReport',
      }}}):_vm._e(),(_vm.referral_users_report_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Referral Users Report',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/ReferralUsersReport',
      }}}):_vm._e(),(_vm.upc_consumer_block_report_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'UPC Consumer Block Report',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/UPCConsumerBlockReport',
      }}}):_vm._e(),(_vm.scheduler_process_report_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Scheduler Process Report',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/SchedulerProcessReport',
      }}}):_vm._e(),(_vm.scheduler_reProcess_report_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Scheduler Re Process Report',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/SchedulerReProcessReport',
      }}}):_vm._e(),(_vm.auditTrail_api_report_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Audit Trail API Report',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/AuditTrailAPIReport',
      }}}):_vm._e(),(_vm.blockUser_api_report_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Block User  API Report',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/BlockUserApiReport',
      }}}):_vm._e(),(_vm.content_view_report_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Content View Report',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/ContentViewReport',
      }}}):_vm._e(),(_vm.chest_prize_report_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Chest Prize Report',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/giftaway/ChestPrizeReport',
      }}}):_vm._e(),(_vm.consumer_raffle_special_report_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Consumer Raffle Special Report',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/raffle/ConsumerRaffleSpecialReport',
      }}}):_vm._e(),(_vm.consumer_raffle_special_event_winner_report_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Consumer Raffle Special Event Winner Report',
        icon: 'ni ni-single-copy-04 text-red',
        path: '/admin/raffle/ConsumerRaffleSpecialEventWinnerReport',
      }}}):_vm._e(),(_vm.userIsAdmin)?_c('div',{staticClass:"dropdown-divider"}):_vm._e(),(_vm.userIsAdmin)?_c('h6',{staticClass:"ml-3 navbar-heading text-muted"},[_vm._v(" Settings ")]):_vm._e(),(_vm.userIsAdmin)?_c('sidebar-item',{attrs:{"link":{
        name: 'Global Configuration',
        icon: 'ni ni-settings text-yellow',
        path: '/admin/config',
      }}}):_vm._e()],1)],2),_c('div',{staticClass:"main-content",attrs:{"data":_vm.sidebarBackground}},[_c('dashboard-navbar'),_c('div',{on:{"click":_vm.toggleSidebar}},[_c('fade-transition',{staticClass:"main",attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1),_c('modal',{attrs:{"show":_vm.isIdle,"modal-classes":"modal"},on:{"update:show":function($event){_vm.isIdle=$event}}},[_c('h4',{staticClass:"modal-title",attrs:{"slot":"header","id":"modal-title-default"},slot:"header"},[_vm._v(" Session Expired - Force Logout ")]),_c('p',[_vm._v(" You have left this browser idle for 1 hour. Please re-login... ")])]),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }